export interface SpaceInfo {
  id: number;
  name?: string;
  objectId?: number;
  description?: string;
  floorId?: number;
  floorName?: string;
  blockId?: number;
  blockName?: string;
  grossArea?: string;
  netArea?: string;
  surfaceArea?: string;
  urn?: string;
  grossVolume?: string;
  isWorkspace: boolean;
  tpId?: number;
}
